import { Logger } from '../../../../../../shared/helpers/loggerFacade';

const STATS_LOG_INTERVAL_MS = 5000;

/**
 * Аккумулятор статистики rVFC skip с периодическим логированием.
 * Считает долю пропущенных отрисовок и раз в 5 секунд выводит в debug-лог.
 */
export class RvfcStatsLogger {
    private _totalDraws = 0;
    private _totalSkipped = 0;
    private _lastLogTime = performance.now();
    private _logger: Logger;

    constructor(logger: Logger) {
        this._logger = logger;
    }

    /** Аккумулирует счётчики за один кадр */
    accumulate(participantCount: number, dirtySetSize: number): void {
        const dirtyCount = Math.min(dirtySetSize, participantCount);

        this._totalDraws += participantCount;
        this._totalSkipped += Math.max(0, participantCount - dirtyCount);
    }

    /** Логирует статистику, если прошло >= 5 секунд с последнего лога */
    maybeLog(trackedCount: number): void {
        const now = performance.now();

        if (now - this._lastLogTime < STATS_LOG_INTERVAL_MS) {
            return;
        }

        const skipRatio = this._totalDraws > 0 ? this._totalSkipped / this._totalDraws : 0;

        this._logger.debug('rvfc-stats', {
            skipRatio: Math.round(skipRatio * 100) / 100,
            trackedVideos: trackedCount,
            totalDraws: this._totalDraws,
            totalSkipped: this._totalSkipped,
            intervalMs: Math.round(now - this._lastLogTime),
        });

        this._totalDraws = 0;
        this._totalSkipped = 0;
        this._lastLogTime = now;
    }
}
